import InterventionModal from './InterventionModal';

export default InterventionModal;
